<template>
  <div>
    <img
      src="@/assets/tarjeta_100_euros_viajar_participacion.jpg"
      style="width:100%"
    />
    <h2>Sorteo</h2>
    <p>
      Por haber contratado un nuevo seguro entre el 16 de mayo y el 15 de julio
      de 2022 (ambas inclusive) y fecha de efecto antes del 16 de julio de 2022,
      puedes participar en el sorteo de 5 premios de 100€ para disfrutar en tu
      próximo viaje.
    </p>

    <div class="campo1" v-if="puedeParticiparSorteo()">
      <label>
        <input v-model="aceptoParticiparSorteo" type="checkbox" /> Acepto las
        condiciones del sorteo para participar
      </label>
    </div>

    <p>
      <a class="containerLlamar">
        <button
          v-if="puedeParticiparSorteo()"
          class="pure-button botonLlamar"
          title="Pulse el botón para participar en el sorteo"
          @click.prevent="registrarParticipacion()"
        >
          Quiero participar
        </button>

        <label v-if="!puedeParticiparSorteo()" class="yaParticipado">
          YA HAS PARTICIPADO
        </label>
      </a>
    </p>

    <a
      href="https://www.mmtseguros.com/hubfs/Bases_Campanas/Bases_100_euros_para_VIAJAR_2022_05.pdf"
      target="_blank"
      class="link"
      >ver condiciones</a
    >

    <SorteoParticipacionOK
      v-if="popUpParticipacionOK"
      @close="participacion(false)"
    />
    <SorteoParticipacionNOK
      v-if="popUpParticipacionNOK"
      :asunto="asunto"
      :mensaje="mensaje"
      @close="noParticipacion(false)"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      popUpParticipacionOK: false,
      popUpParticipacionNOK: false,
      aceptoParticiparSorteo: false,
      asunto: " ",
      mensaje: " ",
    };
  },
  computed: {
    portfolio() {
      return this.$store.state.portfolio;
    },
  },

  methods: {
    registrarParticipacion: async function() {
      if (this.portfolio.haParticipadoSorteo100EurosViajar) {
        this.asunto = "!Atención!";
        this.mensaje =
          "Ya hemos registrado anteriormente tu participación en el sorteo. Sólo puedes participar una vez ";
        this.popUpParticipacionNOK = true;
        return;
      }

      if (this.aceptoParticiparSorteo) {
        await this.$store.dispatch("registraParticipacionSorteo100EurosViajar");
        this.popUpParticipacionOK = true;
        await this.$store.dispatch("getPortfolio");
        await this.portfolio();
      } else {
        this.asunto = "!Atención!";
        this.mensaje = "Antes debes aceptar las condiciones del sorteo";
        this.popUpParticipacionNOK = true;
      }
    },

    participacion(val) {
      this.popUpParticipacionOK = val;
    },

    noParticipacion(val) {
      this.popUpParticipacionNOK = val;
    },

    puedeParticiparSorteo() {
      return !this.portfolio.haParticipadoSorteo100EurosViajar;
    },
  },
};
</script>

<style lang="scss" scoped>
.containerLlamar {
  display: flex;
  width: 100%;
  justify-content: center;
}
.botonLlamar {
  background-color: $colorMMT;
  color: white;
  font-weight: bold;
}
.link {
  display: flex;
  width: 100%;
  justify-content: center;
  color: $colorMMT;
  font-weight: 460;
  margin-right: 3rem;
}
.yaParticipado {
  width: 15rem;
  color: $azulOscuroMMT;
  font-weight: bold;
  border-spacing: 7rem;
  text-align: center;
}
</style>
